module.exports = __webpack_public_path__ + "static/media/12.Puppet Stand.dbf4ec11.JPG";